import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4da9bba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scroller"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = { class: "bold header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_suggestions = _resolveComponent("spaces-suggestions")!
  const _component_spaces_user = _resolveComponent("spaces-user")!

  return (_ctx.spacesStore.search === '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.spacesStore.suggestions.length)
          ? (_openBlock(), _createBlock(_component_spaces_suggestions, {
              key: 0,
              class: "mt-20"
            }))
          : _createCommentVNode("", true),
        _hoisted_2
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "scroller",
        ref: "scroller",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
      }, [
        _createElementVNode("h5", _hoisted_3, "Results for “" + _toDisplayString(_ctx.spacesStore.search) + "”", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spacesStore.searchContactsList, (user) => {
          return (_openBlock(), _createBlock(_component_spaces_user, {
            key: user.accountId + user.contactStatus,
            user: user,
            userType: _ctx.resolveUserType(user.contactStatus, user.accountId)
          }, null, 8, ["user", "userType"]))
        }), 128)),
        _hoisted_4
      ], 544))
}